import { twMerge } from 'tailwind-merge';
import { Para, Stack } from 'ui-components';

type Props = {
  customer?: string;
  couponType: string;
  className?: string;
};

export function CouponSummary({ customer, couponType, className }: Props): React.ReactElement {
  return (
    <Stack gap={2} className={twMerge('text-sm', className)}>
      {customer && (
        <Para>
          <span className="font-aribaubold">Kunde:</span> {customer}
        </Para>
      )}

      <Para>
        <span className="font-aribaubold">Gutschein Typ:</span> {couponType}
      </Para>
    </Stack>
  );
}
